import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useDonationsPublicStore = defineStore('donationsPublic', {
  id: 'donationsPublic',
  state: () => ({
    items: [],
    total: null,
    perPage: 20,
    page: 1,
    lastPage: 1,
    api: '/api/v1/donations-public'
  }),
  getters: {
    itemsByFundraiserId: (state) => (fundraiserId) => {
      return state.items.filter(item => item.fundraiser_id === fundraiserId)
    },
    itemsByFundraiserPageId: (state) => (fundraiserPageId) => {
      return state.items.filter(item => item.fundraiser_page_id === fundraiserPageId)
    },
    ...getters
  },
  actions: {
    async fetchItemsByFundraiserId(fundraiserId) {
      const { data } = await axios.get(`${this.api}`, {
        params: {
          fundraiser_id: fundraiserId,
          not_paginated: true
        }
      })
      this.items = data.data
      return data
    },
    async processCheckout(donationId) {
      const { data } = await axios.post(`${this.api}/${donationId}/process-checkout`)
      this.itemPatchState(data)
      return data
    },
    ...actions
  }
})
